import { Environment } from 'src/app/shared/config/environments';
import { FEATURE_EMOJI_RESTRICTIONS } from 'src/app/shared/featureToggle/constants';

import type { FeatureConfig } from '../types';

export const emojiRestrictionsFeature: FeatureConfig = {
  name: FEATURE_EMOJI_RESTRICTIONS,
  value: {
    [Environment.DEV]: { enabled: true },
    [Environment.STAGING]: { enabled: true },
    [Environment.PROD]: { enabled: true },
  },
  toFeature({ env }) {
    const enabled = this.value![env].enabled;
    return {
      name: this.name,
      enabled,
    };
  },
};
